export enum LANGUAGE_LEVEL {
	A1 = 0,
	A2 = 1,
	B1 = 2,
	B2 = 3,
	C1 = 4,
	C2 = 5,
}
